import { Registration } from 'src/app/models/registration';
import { classifyRegistration } from 'src/app/components/classification-pill/format-token';
import { DatelessArrangementFilter } from './dateless-state.service';

/* =============================================================================
   Live-register feed helpers. Pure functions, unit-tested.

   HARD RULE (build pack §5, acceptance #14): Regtransfers-derived listings,
   prices and source labels never appear on any public surface. Regtransfers
   is an internal discovery source only. The exclusion runs on every feed
   ingest before anything renders and is covered by a permanent test.
   ========================================================================== */

/** Canonical feed layout token for a format: letters as '*', numbers as '-'.
    (The canonical convention letters × numbers maps directly: 2x1 -> "**x-".) */
export function layoutForToken(token: string): string | null {
  const m = (token || '').match(/^([1-4])x([1-4])$/);
  if (!m) return null;
  return '*'.repeat(Number(m[1])) + 'x' + '-'.repeat(Number(m[2]));
}

/** True when a seller string is Regtransfers under any casing/spacing. */
export function isRegtransfers(seller: string | null | undefined): boolean {
  return !!seller && /reg\s*transfers/i.test(seller);
}

/** The public-surface filter: strips Regtransfers rows entirely. */
export function excludeRegtransfers<T extends { seller?: string }>(rows: T[]): T[] {
  return (rows || []).filter((r) => !isRegtransfers(r && r.seller));
}

/** Visible-order arrangement of a listing, derived from the plate itself. */
export function arrangementOf(row: Registration): 'letter-first' | 'number-first' | null {
  const c = classifyRegistration(row && (row.registration || ''));
  return c ? c.arrangement : null;
}

export function matchesArrangement(row: Registration, filter: DatelessArrangementFilter): boolean {
  if (filter === 'both') return true;
  return arrangementOf(row) === filter;
}
